import React from 'react';

class Stack extends React.Component {
  state = {
    nutritionalOpen: false,
    ingredientsOpen: false,
    nutritionalCollapsing: false,
    ingredientsCollapsing: false,
  };

  toggleNutritional(e) {
    e.preventDefault();
    this.setState({
      nutritionalCollapsing: !this.state.nutritionalCollapsing,
    });
    setTimeout(() => {
      this.setState({
        nutritionalCollapsing: !this.state.nutritionalCollapsing,
        nutritionalOpen: !this.state.nutritionalOpen,
      });
    }, 1000);
  }

  toggleIngredients(e) {
    e.preventDefault();
    this.setState({
      ingredientsCollapsing: !this.state.ingredientsCollapsing,
    });
    setTimeout(() => {
      this.setState({
        ingredientsCollapsing: !this.state.ingredientsCollapsing,
        ingredientsOpen: !this.state.ingredientsOpen,
      });
    }, 1000);
  }

  render() {
    if (this.props.results !== null) {
      return (
        <div className="quiz-stack__content">
          <h1 className="results__heading results__heading--kids">
            <img src="//cdn.shopify.com/s/files/1/0232/9618/0301/files/MicrosoftTeams-image_small.png?v=1618244701" alt="" aria-hidden="true" />
            {this.props.results.kidsName.charAt(0).toUpperCase() + this.props.results.kidsName.slice(1)}&rsquo;s Nourished
          </h1>
          <p className="results__intro">
            {this.props.results.parentsName.charAt(0).toUpperCase() + this.props.results.parentsName.slice(1)}, here is {this.props.results.kidsName.charAt(0).toUpperCase() + this.props.results.kidsName.slice(1)}’s personalised gummy vitamin. We recommend these 11 different nutrients to help Nourish and support the needs of {this.props.results.gender.toLowerCase() === 'male' ? 'his' : this.props.results.gender.toLowerCase() === 'female' ? 'her' : 'thier'} mind and body.
          </p>
          <ul>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 515.556 515.556" width="20" height="20"><path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" /></svg>
              {this.props.results.priority}
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 515.556 515.556" width="20" height="20"><path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" /></svg>
              {this.props.results.age} Years old
            </li>
            {(this.props.results.gender.toLowerCase() === 'male' || this.props.results.gender.toLowerCase() === 'female' || this.props.results.selectedDiets) &&
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 515.556 515.556" width="20" height="20"><path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" /></svg>
                {this.props.results.gender.toLowerCase() === 'male' || this.props.results.gender.toLowerCase() === 'female' ? `${this.props.results.gender.charAt(0).toUpperCase() + this.props.results.gender.slice(1)}` : ''}
                {this.props.results.selectedDiets ? `, ${this.props.results.selectedDiets}` : ''}
              </li>
            }
          </ul>
        </div>
      );
    } else {
      return (
        <div className="quiz-stack__content">
          <h1 className="results__heading results__heading--kids">
            <img src="//cdn.shopify.com/s/files/1/0232/9618/0301/files/MicrosoftTeams-image_small.png?v=1618244701" alt="" aria-hidden="true" />
            {this.props.results.kidsName.charAt(0).toUpperCase() + this.props.results.kidsName.slice(1)}&rsquo;s Nourished
          </h1>
          <p className="results__intro">
            {this.props.results.kidsName.charAt(0).toUpperCase() + this.props.results.kidsName.slice(1)}, here's your personalised Nourished stack. We recommend these 7 Nourishments to help optimise your lifestyle, diet and priorities.
          </p>
        </div>
      );
    }
  }
}

export default Stack;
